<div class="offset-md-2 col-md-6">
  <h2 class="text-center">
      Get started by creating a Partition
  </h2>
  <p>
      You are allowed {{ maxPartitions }} partitions. Create and name your first partition by clicking the + icon to the left.  Then go to the Set Rules & Partitions screen to add rules to the partition.
  </p>
</div>
